export default __webpack_public_path__ + "static/media/bg_tomodachi.1479ff9c.svg";